import { PositionedUI } from "./PositionedUI";

const DOT_SIZE = 18; // Defined as a constant for restyling purposes.
const DOT_RADIUS = DOT_SIZE / 2;

export const TICKET_ICON = `<path d="M 0 4 L 18 4 18 7 A 2.2 2 0 1 0 18 11 L 18 14 0 14 0 11 A 2.2 2 0 1 0 0 7" fill="white"/>`;
export const ALERT_ICON = `<path fill="white" fill-rule="evenodd" d="M9.7 0.42C9.4 -0.14 8.6 -0.14 8.3 0.42L0.1 15.8C-0.19 16.34 0.19 17 0.5 17h16.4c0.61 0 0.99-0.66 0.7-1.2L9.7 0.42z M9.63674 11.6532C9.60779 11.7868 9.54989 11.9092 9.4534 11.9982C9.3569 12.0873 9.2411 12.1318 9.11566 12.1207H8.88407C8.76827 12.1318 8.64282 12.0873 8.54633 11.9982C8.44983 11.9092 8.38228 11.7868 8.36298 11.6532L8.03503 5.73323C8.06398 5.46614 8.17013 5.22132 8.35347 5.04326C8.53682 4.8652 8.76841 4.78731 9 4.80956C9.23159 4.78731 9.46318 4.87633 9.64653 5.04326C9.82987 5.22132 9.94567 5.46614 9.96497 5.73323L9.63674 11.6532 M9.2 14.5 A 0.7 0.7 0 1 0 8.8 14.5Z"/>`
export class NotificationDotUI {
	/**
	 *
	 * @param {PositionedUI} parentUI
	 */
	constructor(parentUI, icon, align, onClick) {
		this.container = parentUI.innerDom;
		const document = this.container.ownerDocument;
		this.backgroundColor = "";
		this.count = 0;

		this.notificationHost = createNotificationHost(document, align);
		this.countHost = document.createElement("span");
		this.notificationHost.appendChild(this.countHost);

		if (icon) {
			this.iconHost = createIconHost(icon);
			this.notificationHost.appendChild(this.iconHost);
		}

		if (onClick) {
			// same pattern as MouseInteractionsPlugin - consume the gesture on mousedown so even never gets to ToolController
			this._onMousedown = (e) => {
				e.stopPropagation();
			};
			this._onMouseup = (e) => {
				e.stopPropagation();
				onClick(e);
			};
			this.notificationHost.style.cursor = 'pointer';
			this.notificationHost.addEventListener('mousedown', this._onMousedown);
			this.notificationHost.addEventListener('mouseup', this._onMouseup);
		}

		this.container.appendChild(this.notificationHost);
	}

	setBGColor(bgColor) {
		if (this.backgroundColor === bgColor) return;

		this.backgroundColor = bgColor;
		this.notificationHost.style.backgroundColor = this.backgroundColor;
	}

    setCount(count) {
		if (this.count === count) return;

		if (count === 0) {
			// Hide notification
			this.notificationHost.style.display = "none";
		} else if (count === 1) {
			// if icon, skip single count just show icon.
			if (this.iconHost) this.countHost.style.display = "none";
			else this.countHost.textContent = count;
			this.notificationHost.style.display = "flex";
		} else {
			// Show notification with icon and count
			if (count > 99) {
				this.countHost.textContent = "99+";
			} else {
				this.countHost.textContent = count;
			}
			this.countHost.style.display = "block";
			this.notificationHost.style.display = "flex";
		}

		this.count = count;
    }

	dispose() {
		if (this._onMouseup) {
			this.notificationHost.removeEventListener('mousedown', this._onMousedown);
			this.notificationHost.removeEventListener('mouseup', this._onMouseup);
		}
		this.notificationHost.remove();
	}
}

/**
 * @param {Document} document
 * @param {{ top: string, left: string }} [align]
 */
function createNotificationHost(document, align) {
	const el = document.createElement("div");
	el.classList.add("notification-ui");
	if (align) el.classList.add(`${align.top}-${align.left}-ui`);
	el.style.display = 'none';
	return el;
}

const createIconHost = (icon) => {
	const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	svg.setAttribute("width", "12px");
	svg.setAttribute("viewBox", `0 0 ${DOT_SIZE} ${DOT_SIZE}`);
	svg.innerHTML = icon;
	return svg;
};
